import type { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import React, { memo, useEffect, useState } from 'react';
import type { JSX } from 'react';

type PageWrapperComponentProps = {
    renderBody: JSX.Element,
};

function PageWrapperComponent(props: Readonly<PageWrapperComponentProps>): JSX.Element {

    const currentTheme: Theme = useTheme();

    const [windowSize, setWindowSize] = useState<[number, number]>([1920, 1080]);

    useEffect(() => {

        function updateSize(): void {
            setWindowSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <div 
            style={{
                backgroundColor: currentTheme.palette.background.default,
                width: windowSize[0],
                height: windowSize[1],
                float: 'left',
            }}
        >
            {props.renderBody}
        </div>
    );
}

export default memo(PageWrapperComponent);
